import {TouchableOpacityProps, TouchableOpacity} from 'react-native';
import React from 'react';
import {style} from './FloatingButton.styles';

const FloatingButton: React.FC<TouchableOpacityProps> = ({
  children,
  style: styleProp,
  ...restProps
}) => {
  return (
    <TouchableOpacity
      style={[style.container, styleProp]}
      activeOpacity={0.8}
      {...restProps}>
      {children}
    </TouchableOpacity>
  );
};

export default FloatingButton;
